export const Theme = {
    blueMinsk    : '#363B7A',
    supernova    : '#f6cb02',
}